import axios from 'axios';
import * as actionTypes from '../constants/actions';

import baseUrl from '../utils/baseUrl';
import { accountRoute } from '../routes';
import qs from 'qs';

function requestData() {
	return { type: actionTypes.USERS_LOGIN_REQ };
};

function receiveData(type, json) {
	return {
		type: type,
		payload: json,
	};
};

function receiveError(json) {
	return {
		type: actionTypes.RECV_ERROR,
		payload: json,
	};
};

export function login(email, password, remember = 1, success = false, fail = false) {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.post(baseUrl + '/api/account/login', qs.stringify({
			email: email,
			password: password,
			remember: remember,
		}))
		.then(function(response) {
			dispatch(receiveData(actionTypes.USERS_LOGIN, response.data));
			(typeof success === 'function') && success();
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
			(typeof fail === 'function') && fail();
		});
	};
};

export function logout() {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.post(baseUrl + '/api/account/logout')
		.then(function(response) {
			dispatch(receiveData(actionTypes.USERS_LOGOUT, response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
		});
	};
};

export function requestRecovery(email, done = false, fail = false) {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.get(baseUrl + '/api/account/recover', {
			params: {
				email: email,
			},
		})
		.then(function(response) {
			(typeof done === 'function') && done();
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
			(typeof fail === 'function') && fail();
		});
	};
};

export function resetPassword(token, password, done = false, fail = false) {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.get(baseUrl + '/api/account/reset', {
			params: {
				hash: token,
				password: password,
			},
		})
		.then(function(response) {
			(typeof done === 'function') && done();
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
			(typeof fail === 'function') && fail();
		});
	};
};

export function getLogin() {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.get(baseUrl + '/api/account/current')
		.then(function(response) {
			dispatch(receiveData(actionTypes.USERS_LOGIN_INIT, response.data));
		})
		.catch(function(response) {});
	};
};

export function getLoginWithErrors() {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.get(baseUrl + '/api/account/current')
		.then(function(response) {
			dispatch(receiveData(actionTypes.USERS_LOGIN_INIT, response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
		});
	};
};

export function updateLogin(params, success = false, fail = false) {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.put(baseUrl + '/api/account/current', qs.stringify(params))
		.then(function(response) {
			dispatch(receiveData(actionTypes.USERS_LOGIN_INIT, response.data));
			dispatch(receiveData(actionTypes.RECV_MSG, response.data));
			(typeof success === 'function') && success();
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
			(typeof fail === 'function') && fail();
		});
	};
};

export function deleteLogin(success = false, fail = false) {
	return function(dispatch) {
		//dispatch(requestData());
		return axios.delete(baseUrl + '/api/account/current')
		.then(function(response) {
			dispatch(receiveData(actionTypes.USERS_LOGOUT, response.data));
			(typeof success === 'function') && success();
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
			(typeof fail === 'function') && fail();
		});
	};
};



/** WEBPACK FOOTER **
 ** ./frontend/actions/users.js
 **/